import React, { useState } from 'react';

import { RenderPropertyFields } from './RenderPropertyField';

import { RenderSectionTitle, RenderSubtitle } from '../';
import TenantConfig from '../../../config';
import { CreditReportModal, LoanPurpose } from '../../FormElements';
import OwnerItem from '../../OwnerItem';
import {
  ChangePlaid,
  IdVerification,
  NeedDocs,
  PlaidBank,
  SelectBank,
  License,
} from '../../PageElements';

const TENANT_NAME = TenantConfig.getTenant();

export const RenderCurrentSection = ({
  data,
  owners,
  profile,
  error,
  setError,
  preparingRenderFieldProps,
  isEdit,
  appData,
  features,
  sections,
  properties,
  closeTimes,
  activeIndex,
  plaidState,
  isModalOpen,
  updateAndValidateProperty,
  handleMoveSection,
  handleContinue,
  setPlaidState,
  setCloseTimes,
  currentSection,
  isShowCreateForm,
  toggleFieldModal,
  removeCreateForm,
  getCurrentFeature,
  getPropertyFields,
  isPropertyInSection,
  showCreditReportModal,
  handleSkipToNextSection,
  handleCloseCreditModal,
  initializeSectionError,
  handleSaveFileProperty,
  handleUpdateOwners,
  handleGoBackSection,
  editOwnerIndex,
  sanitizeData,
  isMainApplicant,
  appDataRef,
  setShowCreditReportModal,
}) => {
  const sectionProperties = properties.filter((property) =>
    isPropertyInSection(features, sections[activeIndex.sectionIndex], property)
  );
  const plaidFeature = appData?.applicationFeatures?.find(
    (feature) => feature.dataType === 'plaidtoken'
  );
  const currentFeature = getCurrentFeature();
  const accounts =
    plaidFeature && plaidFeature.value ? plaidFeature.value.financialInstruments : [];
  const [showVideoModal, setShowVideoModal] = useState(false);

  const propertyGroup = currentFeature?.propertyGroup || false;
  // console.log(currentFeature, sectionProperties);

  /** Render Single Property Of A Section */
  const renderSinglePropertyInSection = (propertyFeature) => {
    if (propertyFeature == null) {
      return null;
    }
    return (
      <div className="property" key={`property-${propertyFeature.name}`}>
        {RenderSectionTitle({
          propertyFeature,
          isMainApplicant,
          showVideoModal,
          setShowVideoModal,
        })}
        <h3 className="subtitle">{RenderSubtitle({ propertyFeature })}</h3>

        {propertyFeature.dataType === 'plaidtoken' && isEdit && (
          <ChangePlaid
            handleContinue={handleContinue}
            setPlaidState={setPlaidState}
            isEdit={isEdit}
            closeTimes={closeTimes}
            setCloseTimes={setCloseTimes}
            handleSkipToNextSection={handleSkipToNextSection}
            updateAndValidateProperty={updateAndValidateProperty}
          />
        )}
        {propertyFeature.dataType === 'plaidtoken' &&
          !isEdit &&
          (propertyFeature.valueValidated ? (
            <ChangePlaid
              handleContinue={handleContinue}
              setPlaidState={setPlaidState}
              isEdit={isEdit}
              closeTimes={closeTimes}
              setCloseTimes={setCloseTimes}
              handleSkipToNextSection={handleSkipToNextSection}
              updateAndValidateProperty={updateAndValidateProperty}
            />
          ) : (
            <PlaidBank
              handleContinue={handleContinue}
              setPlaidState={setPlaidState}
              closeTimes={closeTimes}
              setCloseTimes={setCloseTimes}
            />
          ))}
        {propertyFeature.dataType === 'loanPurposeDetails' && (
          <LoanPurpose
            toggleFieldModal={toggleFieldModal}
            isModalOpen={isModalOpen}
            initializeSectionError={initializeSectionError}
            handleContinue={handleMoveSection}
            setError={setError}
          />
        )}
        {propertyFeature.itemType === 'IdVerifyProperty' && (
          <IdVerification handleContinue={handleContinue} feature={propertyFeature} />
        )}
        {propertyFeature.itemType === 'LicenseProperty' && (
          <License handleSkipToNextSection={handleSkipToNextSection} setError={setError} />
        )}
        {propertyFeature.dataType === 'financialinstrument' &&
          (plaidState !== 'success' || (plaidState === 'success' && accounts?.length == 0)) && (
            <NeedDocs
              type="component"
              handleContinue={handleContinue}
              handleGoBackSection={handleGoBackSection}
              plaidState={plaidState}
              isEdit={isEdit}
              setCloseTimes={setCloseTimes}
            />
          )}
        {propertyFeature.dataType === 'financialinstrument' && plaidState === 'success' && (
          <SelectBank type="component" handleContinue={handleContinue} isEdit={isEdit} />
        )}
        {propertyFeature.dataType === 'applicant' && owners.length > 0 && (
          <div>
            {owners
              .filter((owner) => owner.firstName)
              .map((owner, index) => (
                <OwnerItem
                  key={'owner' + index}
                  owner={owner}
                  owners={owners}
                  renderFieldProps={preparingRenderFieldProps}
                  handleSaveFileProperty={handleSaveFileProperty}
                  handleUpdateOwners={handleUpdateOwners}
                  index={index}
                  expanded={String(index) == editOwnerIndex || profile.sub === owner.userId}
                  isEdit={isEdit}
                  currentPropertyIndex={activeIndex.propertyIndex}
                  getPropertyFields={getPropertyFields}
                  sectionProperties={sectionProperties}
                  sanitizeData={sanitizeData}
                  setError={setError}
                  isMainApplicant={isMainApplicant}
                  isLoggedinUser={profile.sub === owner.userId}
                  handleSkipToNextSection={handleSkipToNextSection}
                  removeCreateForm={removeCreateForm}
                />
              ))}
          </div>
        )}
        {getPropertyFields(propertyFeature, data).length > 0 &&
        isShowCreateForm &&
        propertyFeature.dataType !== 'loanPurposeDetails'
          ? RenderPropertyFields(
              propertyFeature,
              preparingRenderFieldProps,
              owners,
              handleSaveFileProperty,
              activeIndex,
              error,
              removeCreateForm
            )
          : ''}
        {!isShowCreateForm && error && <p className="error-text form-level">{error}</p>}
        {TenantConfig?.form.showCreditReportModal &&
          propertyFeature &&
          propertyFeature.dataType === 'applicant' && (
            <CreditReportModal
              appId={appDataRef.current?.id}
              showCreditReportModal={showCreditReportModal}
              setShowCreditReportModal={setShowCreditReportModal}
              creditReportCallback={handleCloseCreditModal}
            />
          )}
      </div>
    );
  };

  return (
    <div
      className={`section form-section ${currentSection} ${
        isEdit && currentFeature.name !== 'applicant' ? 'edit-mode' : ''
      } ${TENANT_NAME}`}
    >
      {propertyGroup
        ? sectionProperties.map((property) => {
            const propertyFeature = appData?.applicationFeatures?.find(
              (feature) => feature.name === property
            );
            // console.log(propertyFeature);
            return renderSinglePropertyInSection(propertyFeature);
          })
        : renderSinglePropertyInSection(currentFeature)}
    </div>
  );
};
